import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import App from './App.tsx';
import Login from './components/Login.tsx';
import HistoryPage from './pages/HistoryPage.tsx';
import RunDetailPage from './pages/RunDetailPage.tsx';
import { useAuth } from './context/AuthContext.tsx';

export default function AuthGate() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#468BFF]" />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/history/:id" element={<RunDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
